import { NotificationBarStore } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { GoogleTagManager } from "@next/third-parties/google";
import type { AxiosResponse } from "axios";
import type { NextPage } from "next";
import type { AppProps } from "next/app";
import { SWRConfig } from "swr";
import ApiClient from "~/utils/api/api_client";
import "../styles/global.scss";
import "@itandi/itandi-bb-ui";

const App: NextPage<AppProps> = ({ Component, pageProps }: AppProps) => {
	const gtmId = "GTM-T9SPTWFN";
	return (
		<>
			<GoogleTagManager gtmId={gtmId} />
			<SWRConfig
				value={{
					fetcher: (url: string): Promise<{ data: unknown }> =>
						ApiClient(url).then(
							(r: AxiosResponse<{ data: unknown }>) => r.data
						),
					revalidateOnFocus: false
				}}
			>
				<NotificationBarStore>
					<Component {...pageProps} />
				</NotificationBarStore>
			</SWRConfig>
		</>
	);
};

export default App;
